<!-- @veltra/icons generated sha256:0064280ef041a0ae gen:8 source:src/svg/normal/remove-rectangle.svg -->
<script setup lang="ts">
defineOptions({ name: 'RemoveRectangle' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M2 13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm11 0H3V3h10zm-2.493-4.5H5.493A.496.496 0 0 1 5 8.004c0-.276.217-.504.493-.504h5.014c.276 0 .493.228.493.496a.5.5 0 0 1-.493.504"
    />
  </svg>
</template>
